import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TrlPillContainer, TrlPillLabel } from '../TrlPill.styles';
import { TrlPillParcExecStyled } from './TrlPillParcExec.styles';

export const TrlPillParcExec = () => {
  return (
    <TrlPillContainer>
      <TrlPillParcExecStyled />
      <TrlPillLabel>
        <FormattedMessage id="TRLT_UI-PART_EXEC" />
      </TrlPillLabel>
    </TrlPillContainer>
  );
};
